import { Dispatch, SetStateAction } from 'react';
import { useTranslation } from 'react-i18next';

import { Button } from 'coreOld/components';
import { Size } from 'coreOld/enums';
import UomConversionForm from 'partsOld/components/UomConversionForm';
import UomForm from 'partsOld/components/UomForm';
import UomsHeader from 'partsOld/components/UomsHeader';
import UomsList from 'partsOld/components/UomsList';
import { ICompanyPart } from 'partsOld/types';

import { ButtonWrapper, Wrapper, HeaderWrapper } from './uomsTabStyle';

interface IProps {
  part: Partial<ICompanyPart>;
  setIsAddOpen: Dispatch<SetStateAction<boolean>>;
  setIsEditOpen: Dispatch<SetStateAction<boolean>>;
  closeModal: (reset) => void;
  isAddOpen: boolean;
  isEditOpen: boolean;
  onCancelRemove: () => void;
  onRemove: (reset?) => Promise<void>;
  selectedItem;
  removedItem;
  setSelectedItem?;
}

const UomsTabView = ({
  part,
  isAddOpen,
  setIsAddOpen,
  selectedItem,
  setSelectedItem,
  closeModal,
  onCancelRemove,
  onRemove,
  removedItem,
  isEditOpen,
  setIsEditOpen,
}: IProps) => {
  const { t } = useTranslation();

  return (
    <Wrapper>
      <HeaderWrapper>
        <UomsHeader part={part} setIsEditOpen={setIsEditOpen} />

        <ButtonWrapper>
          <Button size={Size.XS} onClick={() => setIsAddOpen(true)}>
            {t('buttonLabelAdd')}
          </Button>
        </ButtonWrapper>
      </HeaderWrapper>
      <UomsList part={part} setSelectedItem={setSelectedItem} />

      <UomConversionForm
        isAddOpen={isAddOpen}
        closeModal={closeModal}
        selectedItem={selectedItem}
        onRemove={onRemove}
        onCancelRemove={onCancelRemove}
        removedItem={removedItem}
        part={part}
      />

      <UomForm
        isEditOpen={isEditOpen}
        closeModal={() => setIsEditOpen(false)}
        selectedItem={part}
      />
    </Wrapper>
  );
};

export default UomsTabView;
